/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalUserMediaCenterFileResponseV3ThumbnailFromJSON, InternalUserMediaCenterFileResponseV3ThumbnailToJSON, } from './InternalUserMediaCenterFileResponseV3Thumbnail';
/**
 * @export
 */
export const InternalUserMediaCenterFileResponseV3TypeEnum = {
    MediaCenterFile: 'media_center_file'
};
/**
 * Check if a given object implements the InternalUserMediaCenterFileResponseV3 interface.
 */
export function instanceOfInternalUserMediaCenterFileResponseV3(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
export function InternalUserMediaCenterFileResponseV3FromJSON(json) {
    return InternalUserMediaCenterFileResponseV3FromJSONTyped(json, false);
}
export function InternalUserMediaCenterFileResponseV3FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'thumbnail': json['thumbnail'] == null ? undefined : InternalUserMediaCenterFileResponseV3ThumbnailFromJSON(json['thumbnail']),
    };
}
export function InternalUserMediaCenterFileResponseV3ToJSON(json) {
    return InternalUserMediaCenterFileResponseV3ToJSONTyped(json, false);
}
export function InternalUserMediaCenterFileResponseV3ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'name': value['name'],
        'description': value['description'],
        'thumbnail': InternalUserMediaCenterFileResponseV3ThumbnailToJSON(value['thumbnail']),
    };
}
